module.exports = __webpack_public_path__ + "static/media/cupcake.d3226a3d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/static/img/cupcake.jpg
// module id = 562
// module chunks = 0